export class infoController {
	constructor() {
		"ngInject";
	}

	$onClose() {
		this.close({$value: "cancel"});
	}

	$onConfirm() {
		this.close({$value: "confirm"});
	}

}


// WEBPACK FOOTER //
// ./sources/utility/info/info.controller.js